<template>
  <section class="p-2">
    <div>
      <v-form>
        <v-card>
          <v-card-title class="d-flex justify-space-between p-0 m-0">
            <div class="ps-2 headingFontsize">
              payout Commission-Agrani Bank(BDT)
            </div>
            <div>
              <bread-crumb
                :bread-crumbs="['Partner Summary', 'Payout Commission']"
              />
            </div>
          </v-card-title>
          <v-divider class="p-0 m-0 primary--text"></v-divider>
          <!-- <v-toolbar flat dense class="m-1">
            <v-toolbar-title
              >payout Commission-Agrani Bank(BDT)</v-toolbar-title
            >
          </v-toolbar> -->

          <v-row class="ms-1 me-1 mt-2">
            <v-col cols="12" md="3">
              <label class="labelFontsize mb-0">Send Country</label>
              <v-autocomplete
                outlined
                dense
                class="rounded"
                placeholder="Send Country"
              >
              </v-autocomplete>
            </v-col>
            <v-col cols="12" md="3">
              <label class="labelFontsize mb-0">Send Partner</label>
              <v-autocomplete
                outlined
                dense
                class="rounded"
                placeholder="Send Partner"
              >
              </v-autocomplete>
            </v-col>
            <v-col cols="12" md="3">
              <label class="labelFontsize mb-0">Payment Mode</label>
              <v-autocomplete
                outlined
                dense
                class="rounded"
                placeholder="Payment Mode"
              >
              </v-autocomplete>
            </v-col>
            <v-col cols="12" md="3">
              <label class="labelFontsize mb-0">Bank</label>
              <v-autocomplete outlined dense class="rounded" placeholder="Bank">
              </v-autocomplete>
            </v-col>
          </v-row>
          <v-row class="ms-1 me-1">
            <v-col cols="12" md="3">
              <label class="labelFontsize mb-0">Min Amount</label>
              <v-text-field
                outlined
                dense
                class="rounded"
                placeholder="Min Amount"
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" md="3">
              <label class="labelFontsize mb-0">Max Amount</label>
              <v-text-field
                outlined
                dense
                class="rounded"
                placeholder="Max Amount"
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" md="3">
              <label class="labelFontsize mb-0">Commission Value</label>
              <v-text-field
                outlined
                dense
                class="rounded"
                placeholder="External Code 1"
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" md="3">
              <v-switch label="Deduct Commission from Payout Amount">
              </v-switch>
            </v-col>
          </v-row>
          <v-row class="ms-1 me-1 mt-0">
            <v-col cols="12" md="3"
              ><label>Commission Currency:</label>
              <v-radio-group v-model="radioGroup" class="mt-0">
                <v-radio label="BDT"></v-radio>
                <v-radio label="USD"></v-radio>
              </v-radio-group>
            </v-col>

            <v-col cols="12" md="3"
              ><label>Amount Currency:</label>
              <v-radio-group class="mt-0">
                <v-radio label="BDT "></v-radio>
                <v-radio label="USD "></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>

          <div class="row">
            <div class="col-md-12" style="display: flex; justify-content: end">
              <v-btn depressed 
                small
                class="text-capitalize me-7 mb-10"
                color="primary"
                style="width: 100px"
                ><v-icon small>mdi-content-save-plus-outline</v-icon>Add</v-btn
              >
            </div>
          </div>
        </v-card>
        <v-card flat class="ms-2 me-2"
          ><v-data-table fixed-header  height="55vh" :headers="headers" dense>
            <template v-slot:item.actions="{ item }">
              <v-icon
                small
                color="primary"
                class="mr-2"
                @click="editItem(item)"
              >
                mdi-trash-can-outline
              </v-icon>
            </template>
          </v-data-table></v-card
        >
      </v-form>
    </div>
  </section>
</template>
<script>
import BreadCrumb from "@/components/navigations/BreadCrumb.vue";
export default {
  name:"Payout Commission",
  data: () => {
    return {
      headers: [
        { text: "Country", value: "employee_id" },
        { text: "Partner", value: "first_name" },
        { text: "payment Mode", value: "phone_number" },
        { text: "Min AMT", value: "personal_email" },
        { text: "Max AMT", value: "designation" },
        { text: "Amount Currency", value: "actions" },
        { text: "Value", value: "designation" },
        { text: "Commission Currency", value: "designation" },
        { text: "Deduct Payout Currency", value: "designation" },
        { text: "Action", value: "actions", sortable: false },
      ],
      userList: [],
      search: "",
    };
  },
  components: {
    BreadCrumb,
  },
};
</script>
<style scoped lang="scss">
@import "@/global.scss";
</style>
